export default __webpack_public_path__ + "static/media/dots_top.14b42779.svg";